import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import WhyOncq from "../../Home/component/WhyOncq";
import { ROUTE } from "../../route/Route";
import WhyOncqSection from "../BengaluruLab/WhyOncqSection";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import DepartmentCard from "../Departments/component/departmentCard";
import GurugramForm from "../GurugramLab/gurugramForm";
import Facility from "../labDetail/component/Facility";
import Payment from "../labDetail/component/Payment";
import SeoAdd from "../Seo/SeoAdd";
import DoctorList from "./DoctorList";
import SendQueryModal from "../packageDetail/SendQueryModal";
import ImgSlider from "../BengaluruLab/ImgSlider";

const KolakataLab = () => {
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [code, setCode] = useState<any>("");

  useEffect(() => {
    window?.scrollTo(0, 0);
    let intervalId = setTimeout(() => {
      handleModalOpen("Kolkata Lab");
    }, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleModalOpen = (code: any) => {
    setCode(code);
    setModalIsOpen(true);
  };

  return (
    <>
      <SeoAdd slug={ROUTE.KOLKATALAB} />
      <BreadCrumb page={t("kolkata_lab")} data={{ slug: "", path: "" }} />
      <section className="bg-white section pt-3">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-12">
              <div className="text-center">
                <img
                  src={t("images.kol_lab.banner")}
                  className="scale"
                  alt=""
                />
              </div>
              <div className="headingmains text-center py-3">
                <h1 className="right aos-init pb-3 mt-sm-3 mt-lg-4">
                  {t("about_kolkata_lab")}
                </h1>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <p className="text-center py-2">
                      {t("about_kolkata_lab_info1")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_kolkata_lab_info2")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_kolkata_lab_info3")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_kolkata_lab_info4")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_kolkata_lab_info5")}
                    </p>
                  </div>
                  <div className="col-12 col-md-6 d-flex align-items-start justify-content-end">
                    <div className="w-100">
                      <GurugramForm pageSource="Kolkata Lab" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-8"> */}
              <div className="btm_overview">
                <WhyOncqSection />
               
              </div>
      

          </div>

       


          <DepartmentCard />
          <section className="kolkata-doctor-section" aria-labelledby="kolkata-doctor-name">
            <div className="kolkata-doctor-card">
              <div className="kolkata-doctor-portrait-wrap">
                <div className="kolkata-doctor-image-frame">
                  <img
                    src="/assets/images/en/kolkata-lab/dr-debojyoti-ghosh.jpg"
                    alt="Dr. Debojyoti Ghosh, Laboratory Director and Consultant Histopathologist"
                    className="kolkata-doctor-image"
                    loading="lazy"
                  />
                </div>
                <div className="kolkata-doctor-experience">
                  <strong>13+</strong>
                  <span>Years of clinical experience</span>
                </div>
              </div>

              <div className="kolkata-doctor-content">
                <span className="kolkata-doctor-kicker">Meet our laboratory director</span>
                <h2 id="kolkata-doctor-name">Dr. Debojyoti Ghosh</h2>
                <p className="kolkata-doctor-qualification">MBBS (Cal), MD (Pathology)</p>
                <p className="kolkata-doctor-role">
                  Laboratory Director &amp; Consultant Histopathologist
                </p>

                <p className="kolkata-doctor-bio">
                  Dr. Debojyoti Ghosh [MBBS (Cal), MD (Pathology)] is a seasoned Pathologist with over
                  13 years of clinical experience in interventional cytopathology, surgical histopathology,
                  and oncopathology. Currently serving as the Laboratory Director and Consultant
                  Histopathologist at Oncquest Laboratories Ltd., Kolkata, he leads operational governance,
                  quality compliance, and complex histopathological reporting.
                </p>
                <p className="kolkata-doctor-bio">
                  His core areas of expertise encompass immunohistochemistry (IHC), fine needle aspiration
                  cytology (FNAC), and tumor classification with modern molecular diagnostic techniques.
                  Prior to his current position, Dr. Ghosh served as a Consultant Pathologist at Charnock
                  Hospital and held diagnostic responsibilities across top healthcare institutions.
                </p>
                <p className="kolkata-doctor-bio">
                  An active academic contributor, he has authored research papers in peer-reviewed journals
                  and serves as an educator in national pathology workshops, specializing in
                  dermatopathology and hepatopathology.
                </p>

                <div className="kolkata-doctor-expertise" aria-label="Areas of expertise">
                  <span>Histopathology</span>
                  <span>Oncopathology</span>
                  <span>Immunohistochemistry</span>
                  <span>FNAC</span>
                  <span>Molecular diagnostics</span>
                </div>
              </div>
            </div>
          </section>
          {/* <div className="pb-4">
            <DoctorList />
          </div> */}
          <div className="pb-4 text-center headingmains">
            <div className="text-center py-3">
              <h3 className="right aos-init pb-3 mt-sm-3 mt-lg-4">
                {t("home_sample_collection")}
              </h3>
            </div>
            <div className="pb-3">
              <div className="calldt_lab">
                <a className="text" target="_blank" href="tel: 03325704141">
                  <img src="/assets/img/call.png" width="20px" height="20px" />
                  <span style={{ marginLeft: "10px" }}>033- 25704141</span>
                </a>
                <a
                  href={`https://wa.me/+916291432087`}
                  target="_blank"
                  style={{ marginLeft: "10px" }}
                >
                  <img
                    src="/assets/img/whatsapp.png"
                    width="20px"
                    height="20px"
                  />
                  <span style={{ marginLeft: "10px" }}>+91 6291432087</span>
                </a>
              </div>
              {/* <h3 className="right aos-init py-2 mt-3">
                                {t("laboratory_reference")}
                            </h3> */}
              <p className="text-center py-2 text_light">{t("company_name")}</p>
              <div className="text-center py-2">{t("address_kolkata_lab")}</div>
              <div className="py-2">
                <a
                  href="https://goo.gl/maps/nn2LMQJfuyW6RDvg9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="viewMapLink"
                >
                  <span>View Map</span>
                </a>
              </div>
            </div>
          </div>
          <section className="row">
            <div className="col-md-7 col-12">
              <Facility />
            </div>
            <div className="col-md-5 col-12">
              <Payment />
            </div>
          </section>
        </div>
      </section>
      <SendQueryModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        test={false}
        code={code}
        lab={true}
      />
    </>
  );
};

export default KolakataLab;
